const spanishPageData = {
  slug: 'spanish',
  code: 'es',
  name: 'Spanish',
  nativeName: 'Español',
  flag: '🇪🇸',
  accent: 'from-amber-500 to-red-500',
  description: 'Summary notes and quick references for Spanish learners.',
  notes: { summary: [], keyPoints: [], quickReference: [] },
};

export default spanishPageData;
